import MobileDetect from "mobile-detect";
var isMobileDevice = function () {
    var detect = new MobileDetect(window.navigator.userAgent);
    return detect.mobile();
};
export default isMobileDevice;
